import React from 'react';

import Layout from '../../components/Layout';
import CareersTemplate from '../../templates/careersTemplate';

const Careers = () => {
  return (
    <Layout pageTitle='careers'>
      <CareersTemplate location='danbury' />
    </Layout>
  );
};

export default Careers;
